module.exports = __webpack_public_path__ + "static/media/E2.e1c337a9.png";